import {
  HistoryApi,
  ControlcenterMelcoModelsEmailListItem,
  useAPIQuery,
} from "melco-shared-logic";
import isEmpty from "lodash-es/isEmpty";
import { useTable } from "../table/useTable";
import { useTableErrorComponent } from "../table/useTableErrorComponent";
import { EmailHistoryListFiltersType } from "./EmailHistoryListFiltersType";
//import { EmailHistoryListFiltersType } from "./EmailHistoryFilterType";

export const useEmailHistory = () => {
  const {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    filtersChange,
    sorter,
    currentPage,
    pageSize,
    sortBy,
    searchQuery,
    searchQueryChange,
  } = useTable<
    ControlcenterMelcoModelsEmailListItem,
    EmailHistoryListFiltersType
  >({
    pageSizeOptions: [10, 20],
    pageSize: 20,
  });

  //const baseApiConfig = useBaseAPIConfig();
  const query = useAPIQuery(
    HistoryApi,
    ["emailHistory", currentPage, pageSize, filters, sortBy(), searchQuery],
    async (api) => {
      //  const api = new ControlCenterApi(baseApiConfig({ token }));
      console.log({ filters, currentPage, pageSize });
      let response;
      //if (filters?.searchText && !isEmpty(filters.searchText)) {

      response = await api.manageSearchEmails({
        offset: (currentPage - 1) * pageSize,
        limit: pageSize,
        sortBy: sortBy(),
        productCodeList:
          filters?.productCode && !isEmpty(filters.productCode)
            ? filters.productCode.join(",")
            : undefined,
        searchText:
          filters?.searchText && !isEmpty(filters.searchText)
            ? filters.searchText
            : "",
        emailAddress:
          filters?.emailAddress && !isEmpty(filters.emailAddress)
            ? filters.emailAddress
            : "",
        startTimestamp: filters?.startTimeStamp
          ? filters.startTimeStamp
          : undefined,
        endTimestamp: filters?.endTimeStamp ? filters.endTimeStamp : undefined,
      });

      setTotal(response?.total ? response?.total : 0);
      //}

      console.log(response);
      return response?.list ? response?.list : [];
      // return response
    },
    {
      queryOptions: {
        keepPreviousData: true,
      },
    }
  );

  const errorComponent = useTableErrorComponent(query.error, query.refetch);

  return {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    filtersChange,
    sorter,
    searchQuery,
    searchQueryChange,
    errorComponent,
    ...query,
  };
};
